export default __webpack_public_path__ + "static/media/Landscapes-Long.97ebcfae.jpg";